/**
 * ChainVault WP - Footer Component
 * @package ChainVault
 */
import React, { useState } from 'react';

function Modal({ title, body, onClose }) {
    return (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(6px)' }} onClick={onClose}>
            <div style={{ background:'#131313', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'16px', width:'90%', maxWidth:'600px', maxHeight:'80vh', display:'flex', flexDirection:'column' }} onClick={e=>e.stopPropagation()}>
                <div style={{ padding:'20px 24px', borderBottom:'1px solid rgba(255,255,255,0.07)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <span style={{ fontWeight:'800', fontSize:'16px', color:'#fff' }}>{ title }</span>
                    <button onClick={onClose} style={{ background:'none', border:'none', color:'#666', fontSize:'18px', cursor:'pointer' }}>✕</button>
                </div>
                <div style={{ padding:'20px 24px', overflowY:'auto', flex:1, color:'#ccc', fontSize:'14px', lineHeight:'1.8' }}
                    dangerouslySetInnerHTML={{ __html: body || '<p>No content available.</p>' }} />
            </div>
        </div>
    );
}

function Footer() {
    const b = window.chainvaultSettings?.branding || {};
    const [ modal, setModal ] = useState(null);

    if ( b.footer_enabled === '0' ) return null;

    const appName   = b.app_name   || 'ChainVault';
    const tagline   = b.footer_tagline   || 'The all-in-one crypto wallet';
    const copyright = b.footer_copyright || `© ${new Date().getFullYear()} ${appName}. All rights reserved.`;

    const socials = [
        { key:'social_facebook',  icon:'📘', label:'Facebook'  },
        { key:'social_twitter',   icon:'🐦', label:'X'         },
        { key:'social_youtube',   icon:'📺', label:'YouTube'   },
        { key:'social_tiktok',    icon:'🎵', label:'TikTok'    },
        { key:'social_instagram', icon:'📸', label:'Instagram' },
        { key:'social_telegram',  icon:'✈️', label:'Telegram'  },
        { key:'social_discord',   icon:'💬', label:'Discord'   },
    ].filter( s => b[s.key] );

    return (
        <footer style={{ background:'rgba(255,255,255,0.02)', borderTop:'1px solid rgba(255,255,255,0.06)', padding:'24px 20px', marginTop:'40px' }}>
            <div style={{ maxWidth:'1200px', margin:'0 auto' }}>

                { /* Top row — brand + socials */ }
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'16px', marginBottom:'16px' }}>
                    <div>
                        <div style={{ fontWeight:'800', fontSize:'18px', background:'linear-gradient(135deg,#6C63FF,#FC72FF)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
                            { b.logo_icon || '⛓' } { appName }
                        </div>
                        <div style={{ fontSize:'12px', color:'#555', marginTop:'4px' }}>{ tagline }</div>
                    </div>

                    { socials.length > 0 && (
                        <div style={{ display:'flex', gap:'10px', flexWrap:'wrap' }}>
                            { socials.map( s => (
                                <a key={s.key} href={b[s.key]} target="_blank" rel="noopener noreferrer"
                                    style={{ width:'36px', height:'36px', borderRadius:'8px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.08)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'16px', textDecoration:'none', transition:'all 0.2s' }}
                                    onMouseEnter={e=>e.currentTarget.style.background='rgba(108,99,255,0.15)'}
                                    onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.05)'}>
                                    { s.icon }
                                </a>
                            ))}
                        </div>
                    )}
                </div>

                { /* Bottom row — links + copyright */ }
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'10px', paddingTop:'16px', borderTop:'1px solid rgba(255,255,255,0.04)' }}>
                    <div style={{ display:'flex', gap:'16px', flexWrap:'wrap' }}>
                        { b.privacy_enabled !== '0' && (
                            <button onClick={()=>setModal('privacy')}
                                style={{ background:'none', border:'none', color:'#555', fontSize:'12px', cursor:'pointer', padding:0, textDecoration:'underline' }}>
                                { b.privacy_title || 'Privacy Policy' }
                            </button>
                        )}
                        { b.terms_enabled !== '0' && (
                            <button onClick={()=>setModal('terms')}
                                style={{ background:'none', border:'none', color:'#555', fontSize:'12px', cursor:'pointer', padding:0, textDecoration:'underline' }}>
                                { b.terms_title || 'Terms & Conditions' }
                            </button>
                        )}
                        { b.contact_enabled !== '0' && (
                            <button onClick={()=>setModal('contact')}
                                style={{ background:'none', border:'none', color:'#555', fontSize:'12px', cursor:'pointer', padding:0, textDecoration:'underline' }}>
                                { b.contact_title || 'Contact Us' }
                            </button>
                        )}
                    </div>
                    <div style={{ fontSize:'12px', color:'#444' }}>{ copyright }</div>
                </div>
            </div>

            { modal === 'privacy' && <Modal title={b.privacy_title||'Privacy Policy'} body={b.privacy_body} onClose={()=>setModal(null)} /> }
            { modal === 'terms'   && <Modal title={b.terms_title||'Terms & Conditions'} body={b.terms_body} onClose={()=>setModal(null)} /> }
            { modal === 'contact' && <ContactModal onClose={()=>setModal(null)} /> }
        </footer>
    );
}

function ContactModal({ onClose }) {
    const b        = window.chainvaultSettings?.branding || {};
    const apiBase  = window.chainvaultSettings?.siteUrl || '/wp-json/chainvault/v1';
    const [ name,    setName    ] = useState('');
    const [ email,   setEmail   ] = useState('');
    const [ subject, setSubject ] = useState('');
    const [ message, setMessage ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const [ success, setSuccess ] = useState(false);
    const [ error,   setError   ] = useState('');

    const handleSubmit = async () => {
        if ( !name || !email || !subject || !message ) { setError('All fields are required'); return; }
        setLoading(true); setError('');
        try {
            const res  = await fetch( apiBase + '/contact', {
                method: 'POST',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify({ name, email, subject, message }),
            });
            const data = await res.json();
            if ( data.success ) { setSuccess(true); }
            else throw new Error(data.message||'Failed to send');
        } catch(e) { setError(e.message); }
        setLoading(false);
    };

    return (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(6px)' }} onClick={onClose}>
            <div style={{ background:'#131313', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'16px', width:'90%', maxWidth:'480px', padding:'24px' }} onClick={e=>e.stopPropagation()}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
                    <span style={{ fontWeight:'800', fontSize:'16px', color:'#fff' }}>📧 { b.contact_title||'Contact Us' }</span>
                    <button onClick={onClose} style={{ background:'none', border:'none', color:'#666', fontSize:'18px', cursor:'pointer' }}>✕</button>
                </div>

                { success ? (
                    <div style={{ textAlign:'center', padding:'20px' }}>
                        <div style={{ fontSize:'40px', marginBottom:'12px' }}>✅</div>
                        <div style={{ color:'#22c55e', fontWeight:'700', fontSize:'16px', marginBottom:'8px' }}>Message Sent!</div>
                        <div style={{ color:'#888', fontSize:'13px' }}>We'll get back to you at {email} as soon as possible.</div>
                        <button onClick={onClose} style={{ marginTop:'16px', padding:'10px 24px', background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'8px', color:'#ccc', cursor:'pointer', fontFamily:'inherit' }}>Close</button>
                    </div>
                ) : (
                    <div style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
                        { [
                            { label:'Your Name', value:name, set:setName, type:'text', placeholder:'John Doe' },
                            { label:'Email Address', value:email, set:setEmail, type:'email', placeholder:'john@example.com' },
                            { label:'Subject', value:subject, set:setSubject, type:'text', placeholder:'I have a question about...' },
                        ].map((f,i) => (
                            <div key={i}>
                                <label style={{ display:'block', fontSize:'12px', color:'#888', marginBottom:'4px', textTransform:'uppercase', letterSpacing:'0.5px' }}>{ f.label }</label>
                                <input type={f.type} value={f.value} onChange={e=>f.set(e.target.value)} placeholder={f.placeholder}
                                    style={{ width:'100%', padding:'10px 12px', background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'8px', color:'#fff', fontFamily:'inherit', fontSize:'14px', outline:'none', boxSizing:'border-box' }} />
                            </div>
                        ))}
                        <div>
                            <label style={{ display:'block', fontSize:'12px', color:'#888', marginBottom:'4px', textTransform:'uppercase', letterSpacing:'0.5px' }}>Message</label>
                            <textarea value={message} onChange={e=>setMessage(e.target.value)} placeholder="Describe your issue or question..."
                                style={{ width:'100%', padding:'10px 12px', background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'8px', color:'#fff', fontFamily:'inherit', fontSize:'14px', outline:'none', resize:'vertical', height:'100px', boxSizing:'border-box' }} />
                        </div>
                        { error && <div style={{ color:'#ef4444', fontSize:'12px', padding:'8px 12px', background:'rgba(239,68,68,0.1)', borderRadius:'6px' }}>{ error }</div> }
                        <button onClick={handleSubmit} disabled={loading}
                            style={{ padding:'12px', borderRadius:'10px', border:'none', background:'linear-gradient(135deg,#6C63FF,#FC72FF)', color:'#fff', fontWeight:'700', fontSize:'14px', cursor:loading?'not-allowed':'pointer', fontFamily:'inherit', opacity:loading?0.7:1 }}>
                            { loading ? 'Sending...' : '📤 Send Message' }
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Footer;
